// extracted by mini-css-extract-plugin
export default {"base":"older-segment-experience-card-module__base--MPI","top-row":"older-segment-experience-card-module__top-row--ThT","topRow":"older-segment-experience-card-module__top-row--ThT"};